import Backdrop from '@mui/material/Backdrop';
import { useRouter } from 'next/router';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { KeepaWhiteLogoRight } from 'assets';
import useCustomMediaQuery from 'hooks/useCustomMediaQuery';
import useFindLocation from 'hooks/useFindLocation';
import { getAppliesFilter } from 'redux/search/selectors';
import { getSettingsLoading } from 'redux/settings/reducer';
import { booleanParser } from 'utility/booleanParser';

import ImageKit from '../Image';

const CustomBackdrop = () => {
	const { backdrop } = useSelector(getSettingsLoading);
	const { isDesktop } = useCustomMediaQuery();
	const { isSearchPage } = useFindLocation();
	const appliesFilter = useSelector(getAppliesFilter);
	const { query } = useRouter();

	React.useEffect(() => {
		const higherPX = isSearchPage;

		if (backdrop) {
			window.scrollTo({
				top: higherPX
					? isDesktop
						? booleanParser(query?.app_keepa)
							? 190
							: 350
						: booleanParser(query?.app_keepa)
							? 40
							: 85
					: 0,
				behavior: 'smooth',
			});
		}
	}, [backdrop, isSearchPage, isDesktop, appliesFilter, query?.app_keepa]);

	return (
		<div style={{ display: backdrop ? 'flex' : 'none' }}>
			<Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdrop}>
				<ImageKit src={KeepaWhiteLogoRight} quality={10} priority width={160} height={160} />
			</Backdrop>
		</div>
	);
};

export default CustomBackdrop;
